var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice"},[_c('div',{staticClass:"content--main"},[(_vm.invoiceId && _vm.userId)?_c('Invoice',{attrs:{"scope":"setting","invoiceId":_vm.invoiceId}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }